import { render, staticRenderFns } from "./practice_games_user_app.vue?vue&type=template&id=38e7d44a&"
import script from "./practice_games_user_app.vue?vue&type=script&lang=js&"
export * from "./practice_games_user_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports